<template>
    <div class="row">
        <input-select class="col-8" label="Indicador" ref="tipo" required :options="options.tipo" v-model="form.tipo"/>
        <input-radio class="col-4" label="Possibilidade de impacto?" ref="possibilidade" required :options="options.simnao" v-model="form.possibilidadeImpacto" />
    
        <input-textarea class="col-12" label="Descrição do impacto" ref="descricao" required v-model="form.descricao"/>
    </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect.vue";
import InputRadio from "@/components/inputs/InputRadio.vue";
import InputTextarea from "@/components/inputs/InputTextarea.vue";

import helpers from "@/common/utils/helpers";

import {FormMixin} from "@/common/mixins/FormMixin";
import cloneDeep from "lodash/cloneDeep";

export default {
    name: "ModalImpactoSocioambiental",
    mixins: [FormMixin],
    components: {
        InputSelect,
        InputTextarea,
        InputRadio,
    },    
    data : () => ({
        form : {
            tipo: null,
            possibilidadeImpacto: 'N',
            descricao: null,
        },
        options : {
            tipo : helpers.getTiposImpactoSocioambiental(),
            simnao : [
                {value: 'S', text: "Sim"},
                {value: 'N', text: "Não"}
            ]
        }
    }),
    methods : {
        salvar : function(){
            let form = cloneDeep(this.form);

            this.$emit('salvar', form);
        },
        editar : function(e){
            let form = cloneDeep(e);

            this.form = form;
        },
    },
}
</script>
<style lang="">
    
</style>